import { render, staticRenderFns } from "./totalDebt.vue?vue&type=template&id=282c9a09&scoped=true&"
import script from "./totalDebt.vue?vue&type=script&lang=js&"
export * from "./totalDebt.vue?vue&type=script&lang=js&"
import style0 from "./totalDebt.vue?vue&type=style&index=0&id=282c9a09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282c9a09",
  null
  
)

export default component.exports